/**
 * Shared styles for rich text elements
 * These styles are used by both the rich-text editor and the rich-text display component
 */

export const getRichTextContainerStyles = (
  containerId: string,
  linkColor: string,
) => `
  #${containerId} a:not(.ql-tooltip *) {
    color: ${linkColor};
  }
  
  #${containerId} p {
    display: block;
    margin: 0;
  }
  
  #${containerId} span,
  #${containerId} strong,
  #${containerId} em, 
  #${containerId} u, 
  #${containerId} s {
    display: inline-block;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
    vertical-align: top;
  }
`;

// For the editor, we also need to reset div padding
export const getRichTextEditorContainerStyles = (
  containerId: string,
  linkColor: string,
) => `
  #${containerId} div {padding: 0px;}
  ${getRichTextContainerStyles(containerId, linkColor)}
`;
